import { useEffect, useState } from "react";

import api from "../../services/api";
import { renderError } from "../../helpers/errors";

// Condições e formas ativas para um uso: 'sale' (orçamento/pedido),
// 'purchase' (pedido de compra) ou null (todas — o cadastro da empresa serve
// para cliente e fornecedor). A forma usa o vocabulário do financeiro.
export const usePaymentOptions = (usage = 'sale') => {
    const [terms, setTerms] = useState([]);
    const [methods, setMethods] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const methodUsage = { sale: 'receivable', purchase: 'payable' }[usage];

        setLoading(true);

        Promise.all([
            api.get(`/payment-term`, { params: { active: 1, usage: usage ?? undefined } }),
            api.get(`/payment-method`, { params: { active: 1, usage: methodUsage } }),
        ]).then(([termsResponse, methodsResponse]) => {
            setTerms(termsResponse.data.resources);
            setMethods(methodsResponse.data.resources);
        }).catch(renderError).then(() => setLoading(false));
    }, [usage]);

    const addTerm = term => setTerms(current =>
        [...current.filter(item => item.id !== term.id), term].sort((a, b) => a.name.localeCompare(b.name))
    );

    return { terms, methods, loading, addTerm };
};

export default usePaymentOptions;

// Formas para os selects do financeiro: todas as ativas, mais a que o título
// já tem caso tenha sido inativada depois.
export const usePaymentMethodOptions = (currentId = null) => {
    const [methods, setMethods] = useState([]);

    useEffect(() => {
        api.get(`/payment-method`).then(res => setMethods(res.data.resources)).catch(renderError);
    }, []);

    const options = methods
        .filter(method => method.active || method.id === currentId)
        .map(method => ({ label: method.active ? method.name : `${method.name} (inativa)`, value: method.id }));

    const getLabel = id => methods.find(method => method.id === id)?.name ?? '';

    return { options, getLabel };
};
